export const advancedSearchBarTestSelectors = {
  searchResult: (patientId: number) => `searched-patient-row-${patientId}`
};
